// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vitessce-container {
    height: 900px;
    width: 100%;
}

.vitessce-container button[type="submit"] {
    cursor: pointer;
    border: 0px;
    border-radius: 0px;
    padding: 1px 6px;
    background-color: transparent;
    color: rgb(98, 98, 98);
}`, "",{"version":3,"sources":["webpack://./src/utils/vitessce.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,sBAAsB;AAC1B","sourcesContent":[".vitessce-container {\n    height: 900px;\n    width: 100%;\n}\n\n.vitessce-container button[type=\"submit\"] {\n    cursor: pointer;\n    border: 0px;\n    border-radius: 0px;\n    padding: 1px 6px;\n    background-color: transparent;\n    color: rgb(98, 98, 98);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
